
<mat-card style="box-shadow:none;    padding: 0px !important;" [class.mat-elevation-z1]="'true'">
    <mat-card-header>
        <span mat-card-avatar>
        <mat-icon>account_circle</mat-icon>
        </span>
        <mat-card-title>{{ isCarrierEmail ? 'Edit Carrier Contact Email' : (isEmail ? 'Add Email Address': 'Add Vehicle/Trailer Registration Number') }}</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>
<mat-dialog-content>
    <div style="color: #3eb849; font-size: 13px; margin-bottom: 8px;" *ngIf="!isEmail && !isCarrierEmail">
        Please only create the vehicle/trailer registration - Single vehicle/trailer Reg only
    </div>
    <mat-form-field style="margin-top: 10px; width: -webkit-fill-available;" class="example-full-width">
        <mat-label>{{ (isEmail || isCarrierEmail) ? 'Email Address': 'Registration Number'}}</mat-label>
        <input matInput placeholder="{{(isEmail || isCarrierEmail) ? 'e.g: abc@amco.uk; abc@3.com': ''}}" [(ngModel)]="regNumber">
    </mat-form-field>
    <div *ngIf="validationError" style="color: #bf1e2e; font-size: 12px; margin-top: 4px;">
        {{validationError}}
    </div>
</mat-dialog-content>
<mat-dialog-actions>
<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 50px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="onCancelClick()">Cancel</button>

<button style="  font-size: 10px;
margin-right: 5px;
scale: 1;
background: #bf1e2e;
color: white;
border-radius: 0px;
text-shadow: none;
box-shadow: none;
flex: 1 1 100%;
box-sizing: border-box;
max-width: 65px;
cursor: pointer;
transition: background-color 0.3s;
box-shadow: none !important;" mat-raised-button (click)="addClick()">Add</button>
</mat-dialog-actions>
</mat-card>

